module.exports = __webpack_public_path__ + "media/recipes/57-9192d4f7.png";